<template>
  <svg fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M14.3789 1.5C13.8361 1.5 13.2933 1.70672 12.8789 2.12109L12 3L15 6L15.8789 5.12109C16.7069 4.29309 16.7069 2.94984 15.8789 2.12109C15.4645 1.70672 14.9217 1.5 14.3789 1.5ZM10.875 4.125L2.25 12.75V15.75H5.25L13.875 7.125L10.875 4.125Z"
      fill="currentColor"></path>
  </svg>
</template>
